import initEndpoints from '@/api/init'
import authEndpoints from '@/api/auth'
import passwordEndpoints from '@/api/password'
import AddressEndpoints from '@/api/address'
import couponEndPoints from '@/api/coupon'
import favoritEndPints from '@/api/favorit'
import locationsEndPoint from '@/api/locations'
import cardEndpoints from '@/api/card'
import PublicDocsEndpoint from '@/api/publicdocs'
import OrderEndpoint from "@/api/order";
import ReviewsEndpoint from "@/api/reviews";

const endpoints = {
  init: initEndpoints,
  auth: authEndpoints,
  password: passwordEndpoints,
  address: AddressEndpoints,
  coupon: couponEndPoints,
  favorit: favoritEndPints,
  card: cardEndpoints,
  locations: locationsEndPoint,
  publicdocs: PublicDocsEndpoint,
  order: OrderEndpoint,
  reviews:ReviewsEndpoint,
  getApiUrl: (route) => {
    return process.env.BASE_API_URL + route
  }
}

export default endpoints
